<template>
  <b-modal
    :title="whoCall ==='edit' ? 'Modificar Material' : 'Agregar Material'"
    id="addMaterials"
    size="lg"
    v-model="showModal"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    @close="onModalClose()"
  >
    <form
      class="col-12"
      autocomplete="off"
      data-vv-scope="sign-material"
      @submit.prevent="addMaterials"
    >
      <div class="col-12">
        <div class="row">
          <div class="col-md-6 mt-3">
            <label>Categoría</label>
            <select
              type="select"
              class="form-control"
              v-model="arrayMaterial.categoryMaterial"
              v-validate="'required'"
              name="category"
              data-vv-as="Categoría"
            >
              <option
                disabled
                v-bind:value="[{
                  opcionId: 0,
                  descripcion: ''
                }]"></option>
              <option
                v-for="option in listCategorys"
                :selected="option == arrayMaterial.categoryMaterial"
                v-bind:value="[{ opcionId: option.categoryId, descripcion: option.categoryName }]"
                v-bind:key="option.categoryId"
              >
                {{ option.categoryName }}
              </option>
            </select>
            <small v-if="errors.has('sign-material.category')" class="ml-4 text-danger">
              {{errors.first('sign-material.category')}}
            </small>
          </div>
          <div class="col-md-6 mt-3">
            <label>Marca</label>
            <select
              type="select"
              class="form-control"
              v-model="arrayMaterial.brandMaterial"
              v-validate="'required'"
              name="brand"
              data-vv-as="Marca"
            >
              <option
                disabled
                v-bind:value="[{
                  opcionId: 0,
                  descripcion: ''
                }]"></option>
              <option
                v-for="option in listBrands"
                :selected="option == arrayMaterial.brandMaterial"
                v-bind:value="{ opcionId: option.brandId, descripcion: option.brandName}"
                v-bind:key="option.brandId"
              >
                {{ option.brandName }}
              </option>
            </select>
            <small v-if="errors.has('sign-material.brand')" class="ml-4 text-danger">
              {{errors.first('sign-material.brand')}}
            </small>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 mt-3">
            <label>Nombre Material</label>
            <b-form-input
              class="w-100"
              v-model="arrayMaterial.nameMaterial"
              v-validate="'required'"
              type="text"
              name="material"
              data-vv-as="Material"
            />
            <small v-if="errors.has('sign-material.material')" class="ml-4 text-danger">
              {{errors.first('sign-material.material')}}
            </small>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-3">
            <label>Precio</label>
            <b-input-group prepend="$">
              <b-form-input
                type="number"
                v-model="arrayMaterial.priceMaterial"
                v-validate="'required|numeric|min_value:0|max_value:9999999'"
                name="price"
                data-vv-as="Precio"
              />
            </b-input-group>
            <small v-if="errors.has('sign-material.price')" class="ml-4 text-danger">
              {{errors.first('sign-material.price')}}
            </small>
          </div>
          <div class="col-md-6 mt-3">
            <label>SKU</label>
            <b-form-input
              class="w-100"
              v-model="arrayMaterial.skuMaterial"
              v-validate="'required'"
              name="sku"
              data-vv-as="SKU"
            />
            <small v-if="errors.has('sign-material.sku')" class="ml-4 text-danger">
              {{errors.first('sign-material.sku')}}
            </small>
          </div>
        </div>
      </div>
      <br>
      <div class="m-top-20" style="display: flex;justify-content: flex-end;">
        <b-button
          type="submit"
          class="ml-3"
          variant="outline-primary"

        >{{ whoCall === 'edit' ? 'Modificar' : 'Agregar' }}
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import MaterialProcessState from '@/febos/global/materialsRequests/mixins/MaterialProcessState';

export default {
  name: 'PopUpAddMaterials',
  data() {
    return {
      materialState: MaterialProcessState
    };
  },
  props: {
    whoCall: {
      type: String,
      required: false,
      default: ''
    },
    arrayMaterial: {
      categoryMaterial: [{
        opcionId: null,
        descripcion: null
      }],
      brandMaterial: {
        opcionId: null,
        descripcion: null
      },
      nameMaterial: null,
      priceMaterial: null,
      skuMaterial: null,
      imageMaterial: null,
      currencyMaterial: 'CLP',
      stateMaterial: null
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Materials', [
      'listCategorys',
      'listBrands'
    ]),
    showModal: {
      get() {
        return this.modalName === 'PopUpAddMaterials';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Materials', [
      'addNewMaterial',
      'editMaterial'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async addMaterials(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (this.whoCall === 'catalog') {
        this.returnMaterials();
      } else if (this.whoCall === 'new') {
        const isValid = await this.validateForm('sign-material');
        if (!isValid) {
          return;
        }
        this.newMaterial();
      } else if (this.whoCall === 'edit') {
        const isValid = await this.validateForm('sign-material');
        if (!isValid) {
          return;
        }
        this.editMaterial();
      }
    },
    async newMaterial() {
      this.closeModal();
      const addMaterial = {
        marca: {
          opcionId: this.arrayMaterial.brandMaterial.opcionId,
          descripcion: this.arrayMaterial.brandMaterial.descripcion
        },
        categorias: [
          {
            opcionId: this.arrayMaterial.categoryMaterial[0].opcionId,
            descripcion: this.arrayMaterial.categoryMaterial[0].descripcion
          }
        ],
        precio: Number.parseInt(this.arrayMaterial.priceMaterial, 10),
        moneda: 'CLP',
        nombre: this.arrayMaterial.nameMaterial,
        SKU: this.arrayMaterial.skuMaterial,
        estado: this.materialState.ACTIVE
      };
      this.addNewMaterial(addMaterial).then(() => {
        this.$emit('reload');
      });
    },
    async editMaterial() {
      this.closeModal();
      const editMaterial = {
        id: this.arrayMaterial.idMaterial,
        query: {
          marca: {
            opcionId: this.arrayMaterial.brandMaterial.opcionId,
            descripcion: this.arrayMaterial.brandMaterial.descripcion
          },
          categorias: [
            {
              opcionId: this.arrayMaterial.categoryMaterial[0].opcionId,
              descripcion: this.arrayMaterial.categoryMaterial[0].descripcion
            }
          ],
          precio: Number.parseInt(this.arrayMaterial.priceMaterial, 10),
          moneda: 'CLP',
          nombre: this.arrayMaterial.nameMaterial,
          SKU: this.arrayMaterial.skuMaterial,
          estado: this.materialState.ACTIVE,
          servicios: this.arrayMaterial.materialServices
        }
      };
      this.editMaterial(editMaterial).then(() => {
        this.$emit('reload');
      });
    },
    returnMaterials() {
      this.arrayMaterial.imageMaterial = '';
      this.arrayMaterial.currencyMaterial = 'CLP';
      this.$emit('reload');
      this.onModalClose();
    },
    clearData() {
      this.arrayMaterial = {
        categoryMaterial: {
          opcionId: null,
          descripcion: null
        },
        brandMaterial: {
          opcionId: null,
          descripcion: null
        },
        nameMaterial: null,
        priceMaterial: null,
        skuMaterial: null,
        imageMaterial: null,
        currencyMaterial: 'CLP'
      };
    },
    onModalClose() {
      this.closeModal();
    }
  }
};
</script>
